import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	viewedCardDetails: null,
	cardCreationDetails: {},
	cardsList: null,
	closeCard: null,
};

export const cardSlice = createSlice({
	name: 'card',
	initialState,
	reducers: {
		resetState: () => initialState,

		setViewedCardDetails: (state, action) => {
			state.viewedCardDetails = action.payload ?? initialState.viewedCardDetails;
		},

		updateCardCreationDetails: (state, action) => {
			state.cardCreationDetails = {
				...state.cardCreationDetails,
				...action.payload,
			};
		},

		resetCardCreationDetails: state => {
			state.cardCreationDetails = {};
		},
		setCardsList: (state, action) => {
			const { payload: cardsList = initialState.cardsList } = action;
			state.cardsList = cardsList;
		},

		closeCardStart: (state, { payload }) => {
			if (payload.cardId !== state.closeCard?.id) {
				state.closeCard = {
					id: payload.cardId,
					confirms: {},
					assets: {},
				};
			}
		},
		closeCardFinish: (state, { payload }) => {
			const cardInfo = state.cardsList.find(({ Id }) => Id === payload.cardId);
			if (cardInfo) {
				cardInfo.Status = 'closed';
			}
			state.closeCard = null;
		},
		closeCardSetConfirm: (state, { payload }) => {
			if (state.closeCard) {
				state.closeCard.confirms[payload.name] = payload.value;
			}
		},
		closeCardSetWithdrawAddress: (state, { payload }) => {
			if (payload.cardId !== state.closeCard?.id) {
				return;
			}
			const { cardId, assetId, cardAddress, recipientAddress } = payload;
			state.closeCard.assets[payload.assetId] = { cardId, assetId, cardAddress, recipientAddress };
		},
	},
});

export const { setViewedCardDetails, updateCardCreationDetails, resetCardCreationDetails, resetState } =
	cardSlice.actions;

export default cardSlice.reducer;
